import { Component, Input, OnChanges, Renderer2, Inject } from '@angular/core';
import { IhmLink } from '../ihm-link/ihm-link.interface';
import { DOCUMENT } from '@angular/common';

// @dynamic
@Component({
  selector: 'adplus-sidenav',
  templateUrl: './adplus-sidenav.component.html',
  styleUrls: ['./adplus-sidenav.component.scss']
})
export class AdPlusSidenavComponent implements OnChanges {
  @Input() links: IhmLink[];
  @Input() tooltipDisabled = true;

  constructor(private renderer: Renderer2, @Inject(DOCUMENT) private document: Document) {}

  private SIDEBAR_VISIBLE: string = 'sidenav-visible';

  ngOnChanges(): void {
    if (this.links && this.links.length) {
      this.renderer.addClass(this.document.body, this.SIDEBAR_VISIBLE);
    } else {
      this.renderer.removeClass(this.document.body, this.SIDEBAR_VISIBLE);
    }
  }
}
